import { render, staticRenderFns } from "./TeacherYearlyAttendanceTableControl.vue?vue&type=template&id=a84f4924&scoped=true&"
import script from "./TeacherYearlyAttendanceTableControl.vue?vue&type=script&lang=js&"
export * from "./TeacherYearlyAttendanceTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84f4924",
  null
  
)

export default component.exports